/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_Created_UtcInputs */

const en_tables_custom_properties_created_utc = /** @type {(inputs: Tables_Custom_Properties_Created_UtcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties Created UTC`)
};

const de_tables_custom_properties_created_utc = /** @type {(inputs: Tables_Custom_Properties_Created_UtcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created UTC`)
};

/**
* | output |
* | --- |
* | "Properties Created UTC" |
*
* @param {Tables_Custom_Properties_Created_UtcInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_created_utc = /** @type {((inputs?: Tables_Custom_Properties_Created_UtcInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_Created_UtcInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_created_utc(inputs)
	return de_tables_custom_properties_created_utc(inputs)
});